import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForYouSection() {
  const forYou = ['Notas que tu vientre se hincha sospechosamente después de comer.', 'Tienes ropa en el armario que no te pones porque "te marca" demasiado.', 'Estás cansada de consejos de influencers de 20 años que no entienden tu cuerpo.', 'Buscas una solución práctica, realista y basada en la ciencia hormonal.'];
  const notForYou = ['Buscas una pastilla mágica para adelgazar 10 kilos en tres días.', 'No estás dispuesta a cambiar tu café en ayunas por un hábito más saludable.', 'Prefieres seguir contando calorías en lugar de escuchar a tu cuerpo.'];
  return <section className="py-24 bg-white" data-id="element-59">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20" data-id="element-61">
          {/* For You */}
          <FadeIn direction="right" data-id="element-62">
            <div className="bg-[#FAF7F2] p-8 md:p-10 rounded-3xl border border-[#E8EDE6]" data-id="element-63">
              <h3 className="text-2xl md:text-3xl font-bold text-[#2D2A26] mb-8 font-serif" data-id="element-64">
                Este protocolo es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-65">
                {forYou.map((text, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-66">
                    <CheckCircleIcon className="w-6 h-6 text-[#4A6741] flex-shrink-0 mt-1" data-id="element-67" />
                    <span className="text-lg text-[#6B6560] leading-relaxed" data-id="element-68">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not For You */}
          <FadeIn direction="left" delay={0.2} data-id="element-69">
            <div className="bg-white p-8 md:p-10 rounded-3xl border border-gray-100 shadow-sm" data-id="element-70">
              <h3 className="text-2xl md:text-3xl font-bold text-[#2D2A26] mb-8 font-serif" data-id="element-71">
                Esto NO es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-72">
                {notForYou.map((text, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-73">
                    <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-74" />
                    <span className="text-lg text-[#6B6560] leading-relaxed" data-id="element-75">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}